(function () {
  'use strict';

  const bootstrap = document.currentScript;
  const providers = new Map();

  function loadScript(provider, src) {
    if (providers.has(provider)) return providers.get(provider);

    const existing = document.querySelector(`[data-deferred-provider-script="${provider}"]`);
    if (existing) return Promise.resolve(existing);

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      script.dataset.deferredProviderScript = provider;
      script.addEventListener('load', () => resolve(script), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    providers.set(provider, promise);
    return promise;
  }

  window.PADeferredProviders = Object.freeze({ loadScript });

  function activateAppSection(section) {
    if (!section || section.dataset.paAppActivated === 'true') return;

    const template = section.querySelector('template[data-pa-app-template]');
    if (!template) return;

    section.dataset.paAppActivated = 'true';
    const fragment = template.content.cloneNode(true);

    fragment.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });

    const placeholder = section.querySelector('.pa-app-placeholder');
    if (placeholder) placeholder.remove();
    template.replaceWith(fragment);
  }

  function observeAppSections(selector, onActivate) {
    const sections = Array.from(document.querySelectorAll(selector));
    if (!sections.length) return;

    const activate = (section) => {
      activateAppSection(section);
      if (onActivate) onActivate(section);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          activate(entry.target);
        });
      }, { rootMargin: '600px 0px' });

      sections.forEach((section) => observer.observe(section));
    } else {
      window.addEventListener('load', () => sections.forEach(activate), { once: true });
    }
  }

  function analyticsAllowed() {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(
      customerPrivacy &&
      typeof customerPrivacy.analyticsProcessingAllowed === 'function' &&
      customerPrivacy.analyticsProcessingAllowed()
    );
  }

  let visitorEngaged = false;
  let clarityRequested = false;
  let privacyChecks = 0;

  function requestClarity() {
    visitorEngaged = true;
    if (clarityRequested) return;
    if (!analyticsAllowed()) {
      if (privacyChecks < 10) {
        privacyChecks += 1;
        window.setTimeout(requestClarity, 500);
      }
      return;
    }

    clarityRequested = true;
    const clarityId = bootstrap && bootstrap.dataset.clarityId;
    if (!clarityId) return;

    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    const start = () => loadScript('clarity', `https://www.clarity.ms/tag/${clarityId}`).catch(() => {
      clarityRequested = false;
    });

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 1500 });
    } else {
      window.setTimeout(start, 0);
    }
  }

  ['scroll', 'pointerdown', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, requestClarity, { once: true, passive: true });
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (visitorEngaged) requestClarity();
  });

  const instafeedSrc = bootstrap && bootstrap.dataset.instafeedSrc;

  observeAppSections('[data-deferred-provider="loox"]');
  observeAppSections('[data-deferred-provider="instafeed"]', () => {
    const existing = document.querySelector('script[src*="nfcube.com/instafeed"], script[src*="instafeed"]');
    if (!existing && instafeedSrc) loadScript('instafeed', instafeedSrc).catch(() => {});
  });

  const newsletterTrigger = document.querySelector('[data-open-newsletter-popup]');
  const newsletterSrc = bootstrap && bootstrap.dataset.newsletterSrc;

  if (newsletterTrigger && newsletterSrc) {
    newsletterTrigger.addEventListener('click', (event) => {
      if (customElements.get('newsletter-popup')) return;

      event.preventDefault();
      newsletterTrigger.disabled = true;
      const prerequisites = window.PAThemeModules ? window.PAThemeModules.load() : Promise.resolve();

      prerequisites
        .then(() => loadScript('newsletter', newsletterSrc))
        .then(() => {
          newsletterTrigger.disabled = false;
          const popup = document.querySelector('newsletter-popup');
          if (popup && typeof popup.openPopup === 'function') popup.openPopup(event);
        })
        .catch(() => {
          newsletterTrigger.disabled = false;
        });
    });
  }

  const chatTrigger = document.querySelector('[data-deferred-provider="tidio"]');
  if (!chatTrigger) return;

  function openChat() {
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      chatTrigger.hidden = true;
      return true;
    }
    return false;
  }

  function goToChatFallback() {
    window.location.assign(chatTrigger.dataset.chatFallback || '/pages/contact-us');
  }

  chatTrigger.addEventListener('click', () => {
    if (openChat()) return;

    chatTrigger.disabled = true;
    chatTrigger.classList.add('is-loading');
    chatTrigger.querySelector('.pa-chat-trigger__label').textContent = 'Loading chat…';

    const timeout = window.setTimeout(goToChatFallback, 10000);
    const ready = () => {
      window.clearTimeout(timeout);
      if (!openChat()) goToChatFallback();
    };

    document.addEventListener('tidioChat-ready', ready, { once: true });

    const tidioSrc = bootstrap && bootstrap.dataset.tidioSrc;
    if (!tidioSrc) {
      goToChatFallback();
      return;
    }

    loadScript('tidio', tidioSrc).catch(() => {
      window.clearTimeout(timeout);
      goToChatFallback();
    });
  });
})();
